import React from 'react';
import { motion } from 'framer-motion';

// Variantes de transition selon le type de navigation
const variants = {
  // Entrée depuis la droite (navigation vers l'avant)
  slideIn: {
    initial:  { opacity: 0, x: 40 },
    animate:  { opacity: 1, x: 0 },
    exit:     { opacity: 0, x: -40 },
  },
  // Fondu simple
  fade: {
    initial:  { opacity: 0 },
    animate:  { opacity: 1 },
    exit:     { opacity: 0 },
  },
  // Zoom entrant (pour pages modales/importantes)
  zoomIn: {
    initial:  { opacity: 0, scale: 0.95 },
    animate:  { opacity: 1, scale: 1 },
    exit:     { opacity: 0, scale: 1.02 },
  },
  // Remontée depuis le bas (pour pages de jeu)
  slideUp: {
    initial:  { opacity: 0, y: 30 },
    animate:  { opacity: 1, y: 0 },
    exit:     { opacity: 0, y: -20 },
  },
};

/**
 * Wrapper de transition de page
 * variant: 'slideIn' | 'fade' | 'zoomIn' | 'slideUp'
 */
function PageTransition({ children, variant = 'slideIn', className = '' }) {
  const v = variants[variant] || variants.slideIn;

  return (
    <motion.div
      initial={v.initial}
      animate={v.animate}
      exit={v.exit}
      transition={{ duration: 0.22, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={className}
      style={{ width: '100%', willChange: 'transform, opacity' }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
